import { z } from 'zod'

export const medicalOpinionSchema = z
	.object({
		medicalOpinionId: z
			.string()
			.transform((elem) => parseInt(elem, 10))
			.refine((data) => data > 0, {
				message: 'Required',
				path: ['medicalOpinionId'],
			}),
		description: z.string().refine((data) => data.length !== 0, {
			message: 'Required',
			path: ['description'],
		}),
		priority: z.number().refine((data) => data || data !== 0, {
			message: 'Required',
			path: ['priority'],
		}),
		targetUser: z.string().optional(),
	})
	.strict()
